export default __webpack_public_path__ + "static/media/videos2.adde0f2a.jpg";